import * as React from 'react'
import classnames from 'classnames'

export interface Props {
  displayClasses?: string
  children: React.ReactNode
  hideBorder?: boolean
}

const OptionGroup: React.FC<Props> = ({
  displayClasses,
  children,
  hideBorder,
}) => {
  const classes = classnames(
    {'option-list--border': !hideBorder},
    displayClasses
  )
  return <div className={classes}>{children}</div>
}

export default OptionGroup
